// Filename: models/questionnaire/questionnaire.js
define('models/questionnaire/questionnaire',[
    'underscore',
    'backbone',
    // src
    'utils',
    'services/api',
    // models
    'models/questionnaire/question',
    'collections/questionnaire/questions'
], function(_, Backbone, U, API, MQuestion, CQuestions) {

    var MQuestionnaire = Backbone.Model.extend({
        idAttribute: 'id',
        titleAttribute: 'title',
        blacklist: ['group'],

        urlRoot: function() {
            var url = "questionnaires/q/";

            if (this.isNew()) {
                return API.url("groups/" + this.get('group') + '/questionnaires/');
            }

            return API.url(url);
        },

        defaults: function() {
            return {
                title: "",
                guidelines: "",
                oneQuestionPerPage: false,
                shared: false,
                autoLock: false,
                filename: "",
                questions: [],
            };
        },

        initialize: function(attrs, opt) {
            opt = opt || {};
            if (opt.group) this.setGroup(opt.group.id);

            return MQuestionnaire.__super__.initialize.call(this, attrs, opt);
        },

        hasQuestions: function() {
            return this.get('questions').length > 0;
        },

        getQuestions: function() {
            return new CQuestions(this.get('questions'));
        },

        getTitle: function() {
            return this.get('title');
        },

        getQuestionById: function(id) {
            return this.getQuestions().get(id);
        },

        getGroup: function(groupId) {
            return this.get('group');
        },

        setGroup: function(groupId) {
            this.set('group', groupId);
        },

        getAbsoluteUrl: function(opt) {
            opt = _.extend({
                target: "_self"
            }, opt);
            var url = window.env.APP_DOMAIN + '#/group/default/member/me/questionnaires/' + this.id;
            return '<a href="' + url + '" target="' + opt.target + '">' + url + '</a>';
        },

    });

    // Return the model for the module
    return MQuestionnaire;
});

